module.exports = __webpack_public_path__ + "static/media/mott_catalog_page2.ea513788.png";